/**
 * @generated SignedSource<<40debfdc71cc42750e08210b725892e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type syncProjectsToggleFragment$data = {
  readonly projectMappingData: {
    readonly syncNewProjects: boolean | null;
  } | null;
  readonly " $fragmentType": "syncProjectsToggleFragment";
};
export type syncProjectsToggleFragment$key = {
  readonly " $data"?: syncProjectsToggleFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"syncProjectsToggleFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "syncProjectsToggleFragment",
  "selections": [
    {
      "concreteType": "HelpCenterProjectMappingData",
      "kind": "LinkedField",
      "name": "projectMappingData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "syncNewProjects"
        }
      ]
    }
  ],
  "type": "HelpCenter"
};

(node as any).hash = "b09d61797a2afad5be65329bfb50cc92";

export default node;
